/** Clé de l'item « Aucune sélection » injecté en tête des listes combo. */
export const U2000_COMBO_BOX_NONE_ITEM_KEY = '__NONE__';

function getSingleTypeaheadDataItem<T extends Record<string, unknown>>(
  displayItems: T[],
  keyField: keyof T,
): T | null {
  const dataItems = displayItems.filter(
    (item) => String(item[keyField]) !== U2000_COMBO_BOX_NONE_ITEM_KEY,
  );
  return dataItems.length === 1 ? dataItems[0] : null;
}

/** Option surlignée à valider sur Tab (hors typeahead). */
export function resolveHighlightedCommitItem<T extends Record<string, unknown>>(
  displayItems: T[],
  keyField: keyof T,
  highlightedIndex: number,
): T | null {
  if (highlightedIndex < 0 || highlightedIndex >= displayItems.length) {
    return null;
  }
  const highlighted = displayItems[highlightedIndex];
  if (String(highlighted[keyField]) === U2000_COMBO_BOX_NONE_ITEM_KEY) {
    return null;
  }
  return highlighted;
}

/** Option à valider sur Tab pendant un typeahead (match unique ou ligne surlignée). */
export function resolveTypeaheadCommitItem<T extends Record<string, unknown>>(
  displayItems: T[],
  keyField: keyof T,
  typeaheadQuery: string,
  highlightedIndex: number,
): T | null {
  if (!typeaheadQuery.trim()) {
    return null;
  }
  const single = getSingleTypeaheadDataItem(displayItems, keyField);
  if (single) {
    return single;
  }
  return resolveHighlightedCommitItem(displayItems, keyField, highlightedIndex);
}

/** Résout l'item à committer sur Tab (typeahead ou surlignage clavier/souris). */
export function resolveTabCommitItem<T extends Record<string, unknown>>(
  displayItems: T[],
  keyField: keyof T,
  typeaheadQuery: string,
  highlightedIndex: number,
): T | null {
  if (typeaheadQuery.trim()) {
    return resolveTypeaheadCommitItem(displayItems, keyField, typeaheadQuery, highlightedIndex);
  }
  return resolveHighlightedCommitItem(displayItems, keyField, highlightedIndex);
}

/** Indique si le combo affiche une sélection commitée (hors « Aucune sélection »). */
export function u2000ComboBoxHasCommittedSelection<T extends Record<string, unknown>>(
  value: T | null | undefined,
  keyField: keyof T,
  cmbValue: string,
): boolean {
  if (cmbValue.trim().length > 0) {
    return true;
  }
  if (value == null) {
    return false;
  }
  return String(value[keyField]) !== U2000_COMBO_BOX_NONE_ITEM_KEY;
}
